<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="as_code,as_custname"
      placeholder="输入售后编号、客户名称关键字查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/crm/after_sale/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.as_custname }}</p>
          <p class="list-item-muted">{{ item.as_code }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.as_classify }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.as_status_code != 'AUDITED' }"
            >{{ item.as_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}条</label>
    </div>
    <add-button to="/crm/after_sale_edit"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/afterSale/list",
      filters: [
        {
          type: "date",
          name: "as_date",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "as_status_code!='AUDITED'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "as_status_code='AUDITED'",
            },
          ],
        },
      ],
    };
  },
};
</script>